import React from "react";
import { ConnectedRouter } from "react-router-redux";
import { renderRoutes } from "react-router-config";

import { history } from "../redux/router";
import ScrollToTop from "./ScrollToTop";
import routes from "./routes";

history.listen((e) => {
  console.log("history event", e);
  if (e.pathname != window.location.pathname) {
    var stateObj = { category: e.pathname };
    window.history.pushState(stateObj, e.pathname, e.pathname);
  }
});

const Router = () => (
  <ConnectedRouter history={history}>
    <ScrollToTop>{renderRoutes(routes)}</ScrollToTop>
  </ConnectedRouter>
);
export default Router;



// WEBPACK FOOTER //
// ./src/router/Router.jsx